import { SortOptionValue } from '@bridebook/web/app-shared/lib/search/types';

export const defaultSortValue: SortOptionValue = 'favourites';

export const searchResultsPagePrefix = '/search/wedding-';

export enum SearchQueryKey {
  SearchData = 'search-data',
  SearchDataInfinite = 'search-data-infinite',
  SearchDataInfiniteSwiping = 'search-data-infinite-swiping',
  SearchCountData = 'search-count-data',
  Presets = 'presets',
  DerivedParams = 'derived-search-params',
  Interactions = 'interactions',
}

// Vertical offset keeping snackbars clear of the desktop search filters bar
export const SEARCH_SNACKBAR_DESKTOP_OFFSET = 122;
